import React from 'react';
import { INFO_GREY_ICON } from '@Images';
import { SEND_MONEY_CALCULATOR_SCREEN } from '../../utils/constants';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import { IAdditionalInfo } from '../../utils/interface';
import {
  AdditionalDetailsContainer,
  DetailsContainer,
  AddnDetailsContainerRight,
  AddnDetailsContainerLeft,
  TextBoldMedium,
  AdditionalChargesText
} from './style';
import { formatCurrencyAmount } from '@Utils/library';

const AdditionalInfo: React.FC<IAdditionalInfo> = (props) => {
  const { currency, netTaxAmount } = props;
  const { swiftFees, tax, taxInfo, additionalCharges } = SEND_MONEY_CALCULATOR_SCREEN;

  return (
    <AdditionalDetailsContainer>
      <AdditionalChargesText>{additionalCharges}</AdditionalChargesText>
      <DetailsContainer margin={[24, 0, 12, 0]}>
        <AddnDetailsContainerLeft>
          <span className="taxText">
            {tax}
            <Popup
              trigger={
                <img alt="more-info" width={'20px'} src={INFO_GREY_ICON} className="includeFees" />
              }
              size="small"
              content={<p>{taxInfo}</p>}
            />
          </span>
        </AddnDetailsContainerLeft>
        <AddnDetailsContainerRight>
          <TextBoldMedium> {`${formatCurrencyAmount(netTaxAmount)} ${currency}`}</TextBoldMedium>
        </AddnDetailsContainerRight>
      </DetailsContainer>
      <p className="swiftFees">{swiftFees}</p>
    </AdditionalDetailsContainer>
  );
};
export default AdditionalInfo;
